'use client';

import { useRef } from 'react';

import { AuthService } from '@/services/modules/AuthService';

export function useAuthService() {
  const ref = useRef<AuthService | null>(null);
  if (ref.current === null) {
    ref.current = new AuthService();
  }
  return ref.current;
}
